<template>
    <div class="app_view" v-cloak v-show="lang!=''">
        <van-nav-bar
            :title="language.problem_feedback"
            @click-left="onClickLeft"
            @click-right="onClickRight"
            fixed
            placeholder
        >

            <span class="head_record textcolor" slot="right">
                {{language.record}}
            </span>
            <span class="head_record textcolor" slot="left">
                <van-icon name="arrow-left" size="20px" color="#323233"/>
            </span>
        </van-nav-bar>
        <div class="content bgcolor" ref="content" :class="'style'+style">
            <template v-if="failsbtn">
                <failed_load></failed_load>
            </template>
            <template v-if="uploadView">
                <!-- 样式2默认 -->
                <template v-if="style==2">
                    <div class="feedBack_title">
                        <span class="red textcolor">
                        {{language.feedback_type}}
                        </span>
                    </div>
                    <!-- 反馈类型 -->
                    <div class="select_type">
                        <div class="select_type_view" v-for="item in selectType" :class="{'current':item.select}" @click="choostType(item)">
                            {{item.name}}
                            <van-icon name="checked"  class="checked_true" v-if="item.select"/>
                        </div>
                    </div>
                    <!-- 反馈内容 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.feedback_content}}
                        </span>
                    </div>
                    <van-field
                            v-model="message"
                            type="textarea"
                            :placeholder="language.please_describe_your_issue_in_detail_so_we_can_assist_you_better"
                            rows="6"
                            maxlength="200"
                            autosize
                            class="feedbackContent"
                    />
                    <!-- 图片上传 -->
                    <div class="feedBack_title">
                        <span class="textcolor">
                            {{language.upload_screenshots}}
                        </span>
                    </div>
                    <van-uploader  
                    v-model="fileList" 
                    :before-read="imghandelbefore"
                    :after-read="goUpload"
                    :before-delete ="deleteImage"
                    type="primary"
                    accept="image/*"
                    multiple
                    max-count="4"
                    />
                    <!-- 邮件地址 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.contact_information}}
                        </span>
                    </div>
                    <van-field class="emailInput" 
                    v-model="emailValue" 
                    :placeholder="language.enter_your_email_address" />
                    <!-- 邮件地址end -->
                </template>
                <!-- 样式1 -->
                <template v-if="style==1">
                    <div style="display: flex;justify-content: space-between;">
                        <div class="feedBack_title">
                            <span class="red textcolor">
                            {{language.feedback_type}}
                            </span>
                        </div>
                        <div style="flex: 1;text-align: right;font-size: 14px;" class="van-field__control" @click="showPicker = true">
                            {{ selectType.length&&selectType.filter(a=>a.select)[0].name||''}}
                            <van-icon name="arrow" />
                        </div>
                    </div>
                    <van-popup v-model="showPicker" round position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="selectType.length&&selectType.map(a=>a.name)"
                            @cancel="showPicker = false"
                            @confirm="onConfirm"
                            :confirm-button-text='language.sure'
                            :cancel-button-text ='language.cancel'
                        >
                        </van-picker>
                    </van-popup>
                    <!-- 反馈类型 -->
                    <!-- <div class="select_type">
                        <div class="select_type_view" v-for="item in selectType" :class="{'current':item.select}" @click="choostType(item)">
                            {{item.name}}
                            <van-icon name="checked"  class="checked_true" v-if="item.select"/>
                        </div>
                    </div> -->
                    <!-- 图片上传 -->
                    <div class="feedBack_title">
                        <span class="textcolor">
                            {{language.upload_screenshots}}
                        </span>
                    </div>
                    <van-uploader  
                    v-model="fileList" 
                    :before-read="imghandelbefore"
                    :after-read="goUpload"
                    :before-delete ="deleteImage"
                    type="primary"
                    accept="image/*"
                    multiple
                    max-count="4"
                    />
                    <!-- 邮件地址 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.contact_information}}
                        </span>
                    </div>
                    <van-field class="emailInput" 
                    style="margin-bottom:12px;"
                    v-model="emailValue" 
                    :placeholder="language.enter_your_email_address" />
                    <!-- 邮件地址end -->
                    <!-- 反馈内容 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.feedback_content}}
                        </span>
                    </div>
                    <van-field
                            style="margin-bottom:0;"
                            v-model="message"
                            type="textarea"
                            :placeholder="language.please_describe_your_issue_in_detail_so_we_can_assist_you_better"
                            rows="6"
                            maxlength="200"
                            autosize
                            class="feedbackContent"
                    />
                </template>
                <!-- 样式3 -->
                <template v-if="style==3">
                    <div class="feedBack_title">
                        <span class="red textcolor">
                        {{language.feedback_type}}
                        </span>
                    </div>
                    <!-- 反馈类型 -->
                    <div class="select_type">
                        <div class="select_type_view" v-for="item in selectType" :class="{'current':item.select}" @click="choostType(item)">
                            {{item.name}}
                            <van-icon name="checked"  class="checked_true" v-if="item.select"/>
                        </div>
                    </div>
                    <!-- 图片上传 -->
                    <div class="feedBack_title">
                        <span class="textcolor">
                            {{language.upload_screenshots}}
                        </span>
                    </div>
                    <van-uploader  
                    v-model="fileList" 
                    :before-read="imghandelbefore"
                    :after-read="goUpload"
                    :before-delete ="deleteImage"
                    type="primary"
                    accept="image/*"
                    multiple
                    max-count="4"
                    />
                    <!-- 反馈内容 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.feedback_content}}
                        </span>
                    </div>
                    <van-field
                            v-model="message"
                            type="textarea"
                            :placeholder="language.please_describe_your_issue_in_detail_so_we_can_assist_you_better"
                            rows="6"
                            maxlength="200"
                            autosize
                            class="feedbackContent"
                    />
                    <template>
                        <van-popup closeable v-model="stylethreeshow" round position="bottom" :style="{ height: '60%' }">
                            <div class="popupView">
                                <!-- 邮件地址 -->
                                    <div class="feedBack_title">
                                        <span class="red textcolor">
                                            {{language.contact_information}}
                                        </span>
                                    </div>
                                    <van-field class="emailInput" 
                                    v-model="emailValue" 
                                    :placeholder="language.enter_your_email_address" />
                                    <van-button 
                                        style="margin: 20px 0;" 
                                        round  
                                        type="info" 
                                        size="large"
                                        @click="h5saveFun"
                                    >
                                        {{language.submit}}
                                    </van-button>
                                <!-- 邮件地址end -->
                            </div>
                        </van-popup>
                    </template>
                </template>
                <!-- 样式4 -->
                <template v-if="style==4">
                    <!-- 反馈内容 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.feedback_content}}
                        </span>
                    </div>
                    <van-field
                        v-model="message"
                        type="textarea"
                        :placeholder="language.please_describe_your_issue_in_detail_so_we_can_assist_you_better"
                        rows="6"
                        maxlength="200"
                        autosize
                        class="feedbackContent"
                    />
                    <!-- 图片上传 -->
                    <div class="feedBack_title">
                        <span class="textcolor">
                            {{language.upload_screenshots}}
                        </span>
                    </div>
                    <van-uploader  
                        v-model="fileList" 
                        :before-read="imghandelbefore"
                        :after-read="goUpload"
                        :before-delete ="deleteImage"
                        type="primary"
                        accept="image/*"
                        multiple
                        max-count="4"
                    />
                    <template>
                        <van-popup closeable v-model="stylefourshow" round position="bottom" :style="{ height: '75%' }">
                            <div class="popupView">
                                        <div class="feedBack_title">
                                <span class="red textcolor">
                                {{language.feedback_type}}
                                </span>
                            </div>
                            <!-- 反馈类型 -->
                            <div class="select_type">
                                <div class="select_type_view" v-for="item in selectType" :class="{'current':item.select}" @click="choostType(item)">
                                    {{item.name}}
                                    <van-icon name="checked"  class="checked_true" v-if="item.select"/>
                                </div>
                            </div>
                                <!-- 邮件地址 -->
                                    <div class="feedBack_title">
                                        <span class="red textcolor">
                                            {{language.contact_information}}
                                        </span>
                                    </div>
                                    <van-field class="emailInput" 
                                    v-model="emailValue" 
                                    :placeholder="language.enter_your_email_address" />
                                    <van-button 
                                        style="margin: 20px 0;" 
                                        round  
                                        type="info" 
                                        size="large"
                                        @click="h5saveFun"
                                    >
                                        {{language.submit}}
                                    </van-button>
                                <!-- 邮件地址end -->
                            </div>
                        </van-popup>
                    </template>
                </template>
                <!-- 样式5 -->
                <template v-if="style==5">
                    <div class="feedBack_title">
                        <span class="red textcolor">
                        {{language.feedback_type}}
                        </span>
                    </div>
                    <!-- 反馈类型 -->
                    <div class="select_type">
                        <div class="select_type_view" v-for="item in selectType" :class="{'current':item.select}" @click="choostType(item)">
                            {{item.name}}
                            <van-icon name="checked"  class="checked_true" v-if="item.select"/>
                        </div>
                    </div>
                    <!-- 反馈内容 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.feedback_content}}
                        </span>
                    </div>
                    <div style="padding:10px;border: 1px solid rgba(0, 0, 0, 0.1);border-radius: 12px;">
                        <van-field
                            v-model="message"
                            type="textarea"
                            :placeholder="language.please_describe_your_issue_in_detail_so_we_can_assist_you_better"
                            rows="6"
                            maxlength="200"
                            autosize
                            :border="false"
                        />
                        <!-- 图片上传 -->
                        <div class="feedBack_title">
                            <span class="textcolor">
                                {{language.upload_screenshots}}
                            </span>
                        </div>
                        <van-uploader  
                        v-model="fileList" 
                        :before-read="imghandelbefore"
                        :after-read="goUpload"
                        :before-delete ="deleteImage"
                        type="primary"
                        accept="image/*"
                        multiple
                        max-count="4"
                        />
                    </div>
                    <!-- 邮件地址 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.contact_information}}
                        </span>
                    </div>
                    <van-field class="emailInput" 
                    v-model="emailValue" 
                    :placeholder="language.enter_your_email_address" />
                    <!-- 邮件地址end -->
                </template>
                <template v-if="style==6">
                    <div class="feedBack_title">
                        <span class="red textcolor">
                        {{language.feedback_type}}
                        </span>
                    </div>
                    <!-- 反馈类型 -->
                    <div style="margin-bottom:12px">
                        <!-- <div class="select_type_view" v-for="item in selectType" :class="{'current':item.select}" @click="choostType(item)">
                            {{item.name}}
                            <van-icon name="checked"  class="checked_true" v-if="item.select"/>
                        </div> -->
                        <van-radio-group v-model="feedbackType">
                            <van-cell-group>
                                <van-cell 
                                    class="textcolor" 
                                    style="padding:10px 0" 
                                    :title="item.name" 
                                    clickable 
                                    v-for="item in selectType"
                                    :key="item.code"
                                    @click="feedbackType=item.code"
                                >
                                    <template #right-icon>
                                        <van-radio :name="item.code" />
                                    </template>
                                </van-cell>
                            </van-cell-group>
                        </van-radio-group>
                    </div>
                    <!-- 反馈内容 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.feedback_content}}
                        </span>
                    </div>
                    <van-field
                            v-model="message"
                            type="textarea"
                            :placeholder="language.please_describe_your_issue_in_detail_so_we_can_assist_you_better"
                            rows="6"
                            maxlength="200"
                            autosize
                            class="feedbackContent"
                    />
                    <!-- 图片上传 -->
                    <div class="feedBack_title">
                        <span class="textcolor">
                            {{language.upload_screenshots}}
                        </span>
                    </div>
                    <van-uploader  
                    v-model="fileList" 
                    :before-read="imghandelbefore"
                    :after-read="goUpload"
                    :before-delete ="deleteImage"
                    type="primary"
                    accept="image/*"
                    multiple
                    max-count="4"
                    />
                    <!-- 邮件地址 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.contact_information}}
                        </span>
                    </div>
                    <van-field class="emailInput" 
                    v-model="emailValue" 
                    :placeholder="language.enter_your_email_address" />
                    <!-- 邮件地址end -->
                </template>
                <template v-if="style==7">
                  <!-- 反馈内容 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.feedback_content}}
                        </span>
                    </div>
                    <van-field
                            v-model="message"
                            type="textarea"
                            :placeholder="language.please_describe_your_issue_in_detail_so_we_can_assist_you_better"
                            rows="6"
                            maxlength="200"
                            autosize
                            class="feedbackContent"
                    />
                    <div class="feedBack_title">
                        <span class="red textcolor">
                        {{language.feedback_type}}
                        </span>
                    </div>
                    <!-- 反馈类型 -->
                    <div class="select_type flexcloum">
                        <div class="select_type_view" v-for="item in selectType" :class="{'current':item.select}" @click="choostType(item)">
                            {{item.name}}
                            <van-icon name="checked"  class="checked_true" v-if="item.select"/>
                        </div>
                    </div>
                    <!-- 图片上传 -->
                    <div class="feedBack_title">
                        <span class="textcolor">
                            {{language.upload_screenshots}}
                        </span>
                    </div>
                    <van-uploader  
                    v-model="fileList" 
                    :before-read="imghandelbefore"
                    :after-read="goUpload"
                    :before-delete ="deleteImage"
                    type="primary"
                    accept="image/*"
                    multiple
                    max-count="4"
                    />
                    <!-- 邮件地址 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.contact_information}}
                        </span>
                    </div>
                    <van-field class="emailInput" 
                    v-model="emailValue" 
                    :placeholder="language.enter_your_email_address" />
                    <!-- 邮件地址end -->
                </template>
                <!-- 样式8 -->
                <template v-if="style==8">
                    <div style="display: flex;justify-content: space-between;">
                        <div class="feedBack_title">
                            <span class="red textcolor">
                            {{language.feedback_type}}
                            </span>
                        </div>
                        <div style="flex: 1;text-align: right;font-size: 14px;" class="van-field__control" @click="showPicker = true">
                            {{ selectType.length&&selectType.filter(a=>a.select)[0].name||''}}
                            <van-icon name="arrow" />
                        </div>
                    </div>
                    <van-popup v-model="showPicker" round position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="selectType.length&&selectType.map(a=>a.name)"
                            @cancel="showPicker = false"
                            @confirm="onConfirm"
                            :confirm-button-text='language.sure'
                            :cancel-button-text ='language.cancel'
                        >
                        </van-picker>
                    </van-popup>
                    <!-- 反馈类型 -->
                    <!-- <div class="select_type">
                        <div class="select_type_view" v-for="item in selectType" :class="{'current':item.select}" @click="choostType(item)">
                            {{item.name}}
                            <van-icon name="checked"  class="checked_true" v-if="item.select"/>
                        </div>
                    </div> -->
                    <!-- 图片上传 -->
                    <div class="feedBack_title">
                        <span class="textcolor">
                            {{language.upload_screenshots}}
                        </span>
                    </div>
                    <van-uploader  
                    v-model="fileList" 
                    :before-read="imghandelbefore"
                    :after-read="goUpload"
                    :before-delete ="deleteImage"
                    type="primary"
                    accept="image/*"
                    multiple
                    max-count="4"
                    />
                    <!-- 邮件地址 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.contact_information}}
                        </span>
                    </div>
                    <van-field class="emailInput" 
                    style="margin-bottom:12px;"
                    v-model="emailValue" 
                    :placeholder="language.enter_your_email_address" />
                    <!-- 邮件地址end -->
                    <!-- 反馈内容 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.feedback_content}}
                        </span>
                    </div>
                    <van-field
                            style="margin-bottom:0;"
                            v-model="message"
                            type="textarea"
                            :placeholder="language.please_describe_your_issue_in_detail_so_we_can_assist_you_better"
                            rows="6"
                            maxlength="200"
                            autosize
                            class="feedbackContent"
                    />
                </template>
                <!-- 样式9 -->
                <template v-if="style==9">
                    <!-- 反馈内容 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.feedback_content}}
                        </span>
                    </div>
                    <div style="padding:10px;border: 1px solid rgba(0, 0, 0, 0.1);border-radius: 12px;">
                        <div style="display: flex;justify-content: space-between;">
                            <div class="feedBack_title">
                                <span class="red textcolor">
                                {{language.feedback_type}}
                                </span>
                            </div>
                            <div style="flex: 1;text-align: right;font-size: 14px;" class="van-field__control" @click="showPicker = true">
                                {{ selectType.length&&selectType.filter(a=>a.select)[0].name||''}}
                                <van-icon name="arrow" />
                            </div>
                        </div>
                        <van-popup v-model="showPicker" round position="bottom">
                            <van-picker
                                show-toolbar
                                :columns="selectType.length&&selectType.map(a=>a.name)"
                                @cancel="showPicker = false"
                                @confirm="onConfirm"
                                :confirm-button-text='language.sure'
                                :cancel-button-text ='language.cancel'
                            >
                            </van-picker>
                        </van-popup>
                        <van-field
                            v-model="message"
                            type="textarea"
                            :placeholder="language.please_describe_your_issue_in_detail_so_we_can_assist_you_better"
                            rows="6"
                            maxlength="200"
                            autosize
                            :border="false"
                        />
                        <!-- 图片上传 -->
                        <div class="feedBack_title">
                            <span class="textcolor">
                                {{language.upload_screenshots}}
                            </span>
                        </div>
                        <van-uploader  
                        v-model="fileList" 
                        :before-read="imghandelbefore"
                        :after-read="goUpload"
                        :before-delete ="deleteImage"
                        type="primary"
                        accept="image/*"
                        multiple
                        max-count="4"
                        />
                    </div>
                    <!-- 邮件地址 -->
                    <div class="feedBack_title">
                        <span class="red textcolor">
                            {{language.contact_information}}
                        </span>
                    </div>
                    <van-field class="emailInput" 
                    v-model="emailValue" 
                    :placeholder="language.enter_your_email_address" />
                    <!-- 邮件地址end -->
                </template>
                <van-button 
                    style="margin: 20px 0;" 
                    round  
                    type="info" 
                    size="large"
                    @click="submission"
                    :loading="btnLoading"
                >
                    {{language.submit}}
                </van-button>
            </template>
            <template v-else>
                <div class="upload_details">
                    <div class="upload_success_icon">
                        <van-icon name="checked"  class="checked_true"/>
                    </div>
                    <div class="upload_view_test">{{language.thank_you_for_your_feedback}}</div>
                    <div class="upload_view_tips">{{replyContent}}</div>
                    <van-button type="info" class="upload_Btn btncolor" @click="onClickLeft">{{language.back}}</van-button>
                </div>
            </template>
        </div>
    </div>
  </template>
  <script>
  import { h5FeedbackType,h5save } from "../../../utils/api";
  import {cosUploadFile} from "@/utils/index"; 
  import { getLangue } from "@/utils/language.js"
  import failed_load from "../404/index.vue"
  export default {
    props: [],
    components: {
        failed_load
    },
    data() {
      return {
        stylethreeshow:false,
        stylefourshow:false,
        language: getLangue(),
        fileList: [],
        selectType:[
            // {
            // select:true,
            // code: 1, 
            // name: "Questões funcionais"
            // },
            // {
            // select:false,
            // code: 4, 
            // name: "Problema de bug"
            // },
            // {
            // select:false,
            // code: 5, 
            // name: "sugestões de produtos "
            // },
            // {
            // select:false,
            // code: 6, 
            // name: "outras perguntas" 
            // }
        ],
        message:'',
        emailValue:'',
        replyContent:'',
        uploadView:true,
        imageList:[],
        lang:'',
        feedbackType:1,
        style:2,
        showPicker:false,
        btnLoading:false
      };
    },
    computed: {
        failsbtn(){
            return this.$store.state.failsbtn; // 获取状态
        }
    },
    created(){
        // document.documentElement.style.setProperty('--bg-color', '#670D09'); 
        // document.documentElement.style.setProperty('--btn-color', '#FFBA3C'); 
        // document.documentElement.style.setProperty('--text-color', '#fff'); 
        // document.documentElement.style.setProperty('--input-text-color', '#968e8a'); 
    },
    mounted:function () {
        window.H5GetDataMethod = this.H5GetDataMethod;
        this.lang = this.getQueryVariable('lang')||''
        if(this.lang=='pt'){
            this.lang = 'pt-br'
        }
        if(this.lang==''){
            return
        }
        if(sessionStorage.getItem('appId')&&sessionStorage.getItem('host')){
            this.getdata()
        }
    },
    methods: {
        sendMessage() {
            // 向原生应用发送消息
            this.sendMessageToNativeApp("back");
        },
        sendMessageToNativeApp(message) {
            // 发送消息给原生应用
            if(this.detectDevice()=='iOS'){
                window.webkit.messageHandlers.messageHandler.postMessage(message);
            }else{
                Android.messageHandler(message)
            }
        },
        detectDevice() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            // iOS detection
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }
            // Android detection
            if (/Android/.test(userAgent)) {
                return "Android";
            }
            return "iOS"
        },
        H5GetDataMethod(data){
            var _t =this;
            // this.tokenString=strings;
            let iosData = data;
            if(typeof iosData=='string'){
                iosData = JSON.parse(data)
            }
            // sessionStorage.setItem('appId', "1851905891339603969")
            // sessionStorage.setItem('userId', '1902000401176174594')
            // _t.getdata()
            // console.log(iosData,'iosData')
            // alert(iosData)
            sessionStorage.setItem('host', iosData.host)
            sessionStorage.setItem('appId', iosData.appId)
            sessionStorage.setItem('userId', iosData.userId)
            if(iosData.bgcolor!=undefined&&iosData.bgcolor!=null&&iosData.bgcolor){
                document.documentElement.style.setProperty('--bg-color', iosData.bgcolor); 
            }
            if(iosData.btncolor!=undefined&&iosData.btncolor!=null&&iosData.btncolor){
                document.documentElement.style.setProperty('--btn-color', iosData.btncolor); 
            }
            if(iosData.textcolor!=undefined&&iosData.textcolor!=null&&iosData.textcolor){
                document.documentElement.style.setProperty('--text-color', iosData.textcolor); 
            }
            if(iosData.inputtextcolor!=undefined&&iosData.inputtextcolor!=null&&iosData.inputtextcolor){
                document.documentElement.style.setProperty('--input-text-color', iosData.inputtextcolor); 
            }
            if(iosData.style!=undefined&&iosData.style!=null&&iosData.style){
                this.style = Number(iosData.style)
            }
            // console.log(sessionStorage.getItem('host'),'host')
            // alert(sessionStorage.getItem('host'),'host')
            if(sessionStorage.getItem('host')){
                _t.getdata()
            }
            return
        
        },
        imghandelbefore(file){
            if(+file.length){
                if(file.length>5||((file.length+this.imageList.length)>5)){
                    this.$toast(getLangue().photo_quantity_limit_reminder);
                    return false
                }
                for(var i=0;i<file.length;i++){
                    if(!this.beforeImgUpload(file[i])){
                        return false
                    }
                }
                return true
            }else{
                return this.beforeImgUpload(file)
            }
        },
        beforeImgUpload(file) {
            var _t = this;
            var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
            const extension =
                testmsg === "jpg" ||
                testmsg === "JPG" ||
                testmsg === "png" ||
                testmsg === "PNG" ||
                testmsg === "jpeg" ||
                testmsg === "JPEG";
                const imgList = [];
                _t.imageList.map((a) => {
                    imgList.push(a);  
                });
            if (imgList.length >= 4) {
                _t.$toast(getLangue().photo_quantity_limit_reminder);
                return false;
            }
            if (!extension) {
                _t.$toast(getLangue().photo_quantity_limit_reminder);
                return false;
            }
            // const isLt5M = file.size / 1024 / 1024 < 5;
            // if (!isLt5M) {
            //     _t.$toast(getLangue().photo_size_limit_reminder);
            //     return isLt5M;
            // }
            return true;
      },
      validateEmail(email) {
        // 正则表达式用于校验电子邮件地址
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        // 使用test方法测试email是否符合模式
        return emailPattern.test(email);
    },
      deleteImage (url, img) {
        this.imageList.filter((item, indexs) => {
            if (img.index === indexs) {
            this.imageList.splice(indexs, 1)
            }
        })
        return true
      },
      async goUpload(event) {
        if(+event.length){
            for(var i =0;i<event.length;i++){
                var img = await cosUploadFile(event[i].file)
                this.imageList.push(img)
            }
            return
        }
        let fileItem = event.file;
        await cosUploadFile(fileItem).then(res => {
            this.imageList.push(res)
        })
      },
      getdata() {
        h5FeedbackType({language:this.lang}).then((res) => {
            if(+res.data.length){
                res.data.map(a=>{
                    a.select = false;
                })
                res.data[0].select = true;
            }
            this.selectType = res.data
        }).catch((e)=>{
            this.$toast(e);
        });
      },
      getQueryVariable(item)
        {
            var sValue = window.location.href.match(new RegExp("[\?\&]" + item + "=([^\&]*)(\&?)", "i"));
            return sValue ? sValue[1] : sValue;
        },
      submission(){
        var style = this.style
        if(style==1||style==2||style==6||style==5||style==7||style==8||style==9){
            this.h5saveFun()
        }else if(style==3){
            if(this.message==''){
                this.$toast(getLangue().please_enter_feedback_content_before_submitting);
                return
            }
            this.stylethreeshow = true
        }else if(style==4){
            if(this.message==''){
                this.$toast(getLangue().please_enter_feedback_content_before_submitting);
                return
            }
            this.stylefourshow = true
        }
      },
      h5saveFun(){
        var _t =this;
        var data = {}
        data.content = this.message;
        data.contact = this.emailValue;
        data.feedbackType = this.feedbackType
        data.language = this.lang
        data.imgList = this.imageList;
        if(data.feedbackType==''){
            this.$toast(getLangue().select_type);
            return
        }
        if(data.content==''){
            this.$toast(getLangue().please_enter_feedback_content_before_submitting);
            return
        }
        if(data.contact==''){
            this.$toast(getLangue().enter_your_email_for_us_to_contact_you);
            return
        }
        if(!this.validateEmail(data.contact)){
            this.$toast(getLangue().please_enter_the_normal_email_format);
            return
        }
        _t.btnLoading=true
        setTimeout(()=>{
            _t.btnLoading=false
        },9000)
        h5save(data).then((res) => {
            // console.log('请求成功')
            // this.$toast(getLangue().submission_successful)
            this.$refs.content.scrollTop = 0;
            this.uploadView = false
            this.replyContent = res.data[0].replyContent
            _t.btnLoading=false
        }).catch((e)=>{
            // console.log('请求失败')
            this.$toast(e);
        });
      },
      choostType(e){
        this.selectType.map(item=>{item.select=false})
        e.select = true;
        this.feedbackType = e.code;
      },
      onConfirm(e,i){
        this.selectType.map(item=>{item.select=false})
        this.selectType[i].select = true;
        this.feedbackType = this.selectType[i].code;
        this.showPicker = false
      },
      onClickLeft(){
        this.sendMessage()
      },
      onClickRight(){
        this.$router.push({name:`feedbackRecord`,query:{'lang':this.lang=='pt-br'?'pt':this.lang}})
      }
    },
  };
  </script>
  <style lang="scss">
  [v-clock]{
    display: none;
  }
  .app_view{
    height: 100vh;
    overflow: hidden;
  }
//   .van-uploader__preview-delete{
//     top:-3px;
//     right:-3px;
//     width: 16px;
//     height: 16px;
//     border-radius: 50%;
//     background-color: rgba(85, 82, 120, 1);
//     .van-uploader__preview-delete-icon{
//         top:0px;
//         right:-1px;
//         font-size: 18px;
//         color:rgba(255, 255, 255, 1);
//         font-weight:500;
//     }
//   }
  .van-uploader__preview-image{
    border-radius: 8px !important;
  }
  </style>
  <style lang="scss" scoped>
  .upload_details{
    position: absolute;
    top:0;
    width:calc(100% - 24px);
    padding:0 12px;
    left:0;
    .upload_success_icon{
        font-size: 88px;
        color:rgba(49, 124, 255, 1);
        padding:40px 0 24px 0;
        text-align: center;
    }
    .upload_view_test{
        font-size: 18px;
        color:rgba(29, 29, 29, 1);
        margin-bottom:14px;
        text-align: center;
    }
    .upload_view_tips{
        font-size: 14px;
        color: rgba(119, 119, 119, 1);
        margin-bottom:24px;
        text-align: center;
    }
    .upload_Btn{
        width:100%;
        height: 56px;
        border-radius: 36px;
        font-size: 20px;
    }
  }
  .feedbackContent{
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    margin-bottom: 12px;
    max-height: 150px;
  }
  .emailInput{
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 12px;
  }
  .content{
    padding:12px 16px;
    height: calc(100vh - 70px);
    overflow-y: auto;
    position: relative;
  }
  .head_record{
    text-decoration: underline;
    color: #323233;
  }
  .feedBack_title{
    margin-bottom:15px;
    span{
        color:#1D1D1D;
        font-size: 16px;
        position: relative;
        &.red{
            &::after{
                position: absolute;
                content: '*';
                right: -10px;
                top:1px;
                color:#DD6D22;
            }
        }
    }
  }
  .select_type{
    display: flex;
    flex-wrap: wrap;
  }
  .select_type_view{
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding:0 20px;
    word-wrap: break-word;
    width: calc(48% - 40px);
    height: 56px;
    display: flex;
    align-items: center;
    text-align: center;
    margin-bottom:12px;
    background-color: #fff;
    position: relative;
    &:nth-of-type(2n){
        margin-left:2%
    }
    &.current{
        border:1px solid rgba(49, 124, 255, 1);
    }
    .checked_true{
        color:rgba(49, 124, 255, 1) ;
        position: absolute;
        right: -3px;
        top:-5px;
        background: #fff;
        border-radius: 50%;
    }
  }
  .flexcloum{
    display: flex;
    overflow-x: auto; /* 允许水平滚动 */
    scroll-behavior: smooth; /* 平滑滚动 */
    flex-wrap:nowrap;
    padding:10px 0;
    .select_type_view{
        border-radius: 8px;
        margin:0;
        flex: 0 0 auto; /* 不增长，不收缩，不占用多余空间 */
        margin-right: 10px; 
        .checked_true{
            right: -5px;
        }
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/view/problemFeedback/index.vue